import { Injectable } from '@angular/core';
import { NgForage, NgForageConfig } from 'ngforage';

@Injectable()
export class ImageService {

  private urlObject = {};

  constructor(
    private readonly ngf: NgForage,
  ) { }

  public async getImageByID(id: string, size: string) {
    let dataURL = this.urlObject[id];
    if (dataURL) {
      return Promise.resolve(dataURL);
    } else {
      let url = `https://imagescbs.blob.core.windows.net/images/${id}/${size}.jpg`;
      return this.getDataURL(url);
    }
    // let promise = this.ngf.getItem(`${id}-${size}`);
    // promise.then(dataURL => {
    //   if (dataURL) {
    //     return dataURL
    //   } else {
    //     let dataURLPromise = this.getDataURL(url);
    //     dataURLPromise.then(dataURL => {
    //       this.ngf.setItem(`${id}-${size}`, dataURL)
    //     });
    //     return dataURLPromise;
    //   }
    // });
    // return promise;
  }

  public async getDataURL(url: string) {
    let p = new Promise(function(resolve, reject) {
      let image = new Image();
      image.crossOrigin = 'Anonymous';
      image.onload = function() {
        var canvas = document.createElement('canvas');
        canvas.width = image.naturalWidth;
        canvas.height = image.naturalHeight;

        canvas.getContext('2d').drawImage(image, 0, 0);
        let URL = canvas.toDataURL('image/png');
        resolve(URL);
      }
      image.onerror = function() {
        reject(`Image with URL ${url} not found`);
      }
      image.src = url;
    });
    return p;
  }


}



// WEBPACK FOOTER //
// ./src/app/core/image.service.ts